import { call } from "redux-saga/effects";
import { takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* whatsAppLogsList(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.WHATSAPP_LOGS.LIST, action.payload, true);
}

function* whatsAppUsageList(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.WHATSAPP_LOGS.USAGE, action.payload, true);
}

function* whatsAppHealthGet(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.WHATSAPP_LOGS.HEALTH, action.payload, true);
}

function* whatsAppExclusionsList(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.WHATSAPP_LOGS.EXCLUSIONS, action.payload, true);
}

function* whatsAppExclusionAdd(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.WHATSAPP_LOGS.EXCLUSIONS, action.payload, true);
}

function* whatsAppExclusionDelete(action: any): any {
  const { id, ...rest } = action.payload || {};
  const url = API_URL.WHATSAPP_LOGS.DELETE_EXCLUSION(String(id));
  yield call(sagaFunction, action, CallApi.DELETE, url, rest, true);
}

export default function* adminWhatsAppSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.WHATSAPP_LOGS.LIST, whatsAppLogsList);
  yield takeLatest(SAGA_ACTIONS.ADMIN.WHATSAPP_LOGS.USAGE, whatsAppUsageList);
  yield takeLatest(SAGA_ACTIONS.ADMIN.WHATSAPP_LOGS.HEALTH, whatsAppHealthGet);
  yield takeLatest(SAGA_ACTIONS.ADMIN.WHATSAPP_LOGS.EXCLUSIONS, whatsAppExclusionsList);
  yield takeLatest(SAGA_ACTIONS.ADMIN.WHATSAPP_LOGS.ADD_EXCLUSION, whatsAppExclusionAdd);
  yield takeLatest(SAGA_ACTIONS.ADMIN.WHATSAPP_LOGS.DELETE_EXCLUSION, whatsAppExclusionDelete);
}
